/** IE can only add and remove one class name at a time. */

import { ensureArray } from './array'

export function addClasses(el, classes) {
  ensureArray(classes).forEach((name) => document.body.classList.add(name))
}

export function removeClasses(el, classes) {
  ensureArray(classes).forEach((name) => document.body.classList.remove(name))
}

export function toggleClasses(el, classes, yes) {
  if (!yes) {
    removeClasses(el, classes)
  } else {
    addClasses(el, classes)
  }
}

export function findNode(input) {
  let node = input

  if (typeof node === 'string') {
    node = document.querySelector(node)
  }

  return node
}
